import { queueDashboardColumnStyles } from '@/helpers/multiQueueDashboard'
import i18n from '@/i18n'

export const layoutTypes = {
    LIST: 'list',
    TABBED: 'tabbed',
} as const

export type LayoutType = typeof layoutTypes[keyof typeof layoutTypes]

export const LAYOUT_TYPE_KEY = 'layout-type'

export const LAYOUT_SETTINGS_GENERAL_TAB = 'general'
export const LAYOUT_SETTINGS_TIMERS_TAB = 'timesounds'
export const LAYOUT_SETTINGS_INTERVALS_TAB = 'interval'
export const LAYOUT_SETTINGS_ADVANCED_TAB = 'advanced'
export const LAYOUT_SETTINGS_STATUS_ALERTS_TAB = 'statusAlerts'

export const LayoutSettingsTabs = [
    {
        label: i18n.t('layout.config.tabGeneral'),
        value: LAYOUT_SETTINGS_GENERAL_TAB
    },
    {
        label: i18n.t('layout.config.tabTimers'),
        value: LAYOUT_SETTINGS_TIMERS_TAB
    },
    {
        label: i18n.t('layout.config.tabIntervals'),
        value: LAYOUT_SETTINGS_INTERVALS_TAB
    },
    {
        label: i18n.t('layout.config.tabAdvanced'),
        value: LAYOUT_SETTINGS_ADVANCED_TAB
    },
    {
        label: i18n.t('layout.config.tabStatusAlerts'),
        value: LAYOUT_SETTINGS_STATUS_ALERTS_TAB
    }
]

export const settingsColors = [
    'primary',
    'background',
    'frames',
    'widgetGroupBackground',
    'widgetGroupFrames',
    'widgetGroupTitles'
]

export const defaultWidgetColors = [
    'background',
    'frames',
    'fonts',
]
export const areaChartWidgetColors = [
    ...defaultWidgetColors,
    'outgoing',
    'incoming'
]

export const queueChartWidgetColors = [
    ...defaultWidgetColors,
    'maxWaitingTime',
    'queueCalls'
]

export const queueGaugeWidgetColors = [
    ...defaultWidgetColors,
    'minimumRangeColor',
    'middleRangeColor',
    'maximumRangeColor',
]

export const multiQueueTableWidgetColors = [
    ...defaultWidgetColors,
    ...Object.keys(queueDashboardColumnStyles).map(el => el.charAt(0).toLowerCase() + el.slice(1))
]

export const predefinedColors = [
    '#F7FAFC',
    '#EDF2F6',
    '#38B2AC',
    '#4299E1',
    '#667EEA',
    '#9F7AEA',
    '#ED8936',
    '#D53F8C',
    '#E53E3E',
    '#000000',
]

export const DEFAULT_LAYOUT_GENERAL_COLORS = [
    'ColorPrimary', // --primary
    'MainBgColor', // --mainBgColor-color
    'DashboardHeaderBgColor', // --dashboardHeaderBgColor-color
    'SecondaryBgColor', // --secondaryBgColor-color
    'ColorFrames', // --frames-color || --ui-lines
    'ColorBackground', // --background-color
]

export const DEFAULT_LAYOUT_TIMERS_SETTINGS = [
    'ActiveCallWarning',
    'ActiveCallLimit',
    'HoldTimeWarning',
    'HoldTimeLimit',
]

export const statusWarningSoundParameter = 88
export const statusLimitSoundParameter = 91

export function isLoginStatusSounds (parameterID: number) {
    return parameterID === statusLimitSoundParameter || parameterID === statusWarningSoundParameter
}
